const properties = ['--dialog-viewport-height', '--dialog-viewport-width', '--dialog-viewport-top', '--dialog-viewport-left']

export const trackDialogViewport = (window, document) => {
    const viewport = window.visualViewport
    const style = document.documentElement.style
    const previous = properties.map(name => [name, style.getPropertyValue(name), style.getPropertyPriority(name)])
    let frame = 0

    const revealInput = () => {
        frame = 0
        const input = document.activeElement
        if (!input?.matches('input, textarea, select, [contenteditable="true"]')) return
        const content = input.closest('.app-dialog-content')
        if (!content) return
        const field = input.closest('.v-field') || input
        const bounds = field.getBoundingClientRect()
        const visible = content.getBoundingClientRect()
        const offset = bounds.bottom > visible.bottom - 12 ? bounds.bottom - visible.bottom + 12
            : bounds.top < visible.top + 12 ? bounds.top - visible.top - 12 : 0
        if (offset) content.scrollTop += offset
    }

    const update = () => {
        const values = [viewport?.height || window.innerHeight, viewport?.width || window.innerWidth,
            Math.max(0, viewport?.offsetTop || 0), Math.max(0, viewport?.offsetLeft || 0)]
        properties.forEach((name, index) => style.setProperty(name, `${values[index]}px`))
        window.cancelAnimationFrame(frame)
        frame = window.requestAnimationFrame(revealInput)
    }

    window.addEventListener('resize', update)
    viewport?.addEventListener('resize', update)
    viewport?.addEventListener('scroll', update)
    document.addEventListener('focusin', update)
    update()

    return () => {
        window.removeEventListener('resize', update)
        viewport?.removeEventListener('resize', update)
        viewport?.removeEventListener('scroll', update)
        document.removeEventListener('focusin', update)
        window.cancelAnimationFrame(frame)
        previous.forEach(([name, value, priority]) => value ? style.setProperty(name, value, priority) : style.removeProperty(name))
    }
}
